module.exports = __webpack_public_path__ + "assets/img/z6.fc056534.png";